import { render, staticRenderFns } from "./LeftChart2.vue?vue&type=template&id=73823876&"
import script from "./LeftChart2.vue?vue&type=script&lang=ts&"
export * from "./LeftChart2.vue?vue&type=script&lang=ts&"
import style0 from "./LeftChart2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports